// Generated from the API's [Reads] declarations by apps/api/Tests/Architecture/WireTypesTests.cs. Do not edit.
// Regenerate: WIRE_TYPES_REGEN=1 dotnet test apps/api/Tests/HooverCanvassingApi.Tests.csproj --filter FullyQualifiedName~WireTypesTests

import type { EntityTag } from './entityTags.gen';

export const EndpointReads = {
  'GET /api/Admin/campaigns/{campaignId}/assistant-access': [
    'AssistantAccessEntry',
    'CampaignUser',
    'CampaignUserCapability',
    'TenantCampaign',
    'Volunteer',
  ],
  'GET /api/Admin/consultants': [
    'TenantCampaign',
    'Volunteer',
  ],
  'GET /api/Admin/users/search': [
    'Volunteer',
  ],
  'GET /api/Analytics/canvasser-performance': [
    'Shift',
  ],
  'GET /api/Analytics/canvasser-stats': [
    'CampaignQuestion',
    'CampaignUser',
    'Contact',
    'ContactAnswer',
    'Shift',
    'Team',
    'TeamMembership',
    'TenantCampaign',
    'Vendor',
    'Volunteer',
  ],
  'GET /api/Analytics/contact-analytics': [
    'CampaignUser',
    'Contact',
    'Shift',
    'Volunteer',
  ],
  'GET /api/Analytics/my-stats': [
    'CampaignUser',
    'Contact',
    'Shift',
    'TenantCampaign',
  ],
  'GET /api/Analytics/vendor-performance': [
    'Shift',
    'TenantCampaign',
  ],
  'GET /api/Analytics/vendor-summary': [
    'CampaignQuestion',
    'CampaignUser',
    'Contact',
    'ContactAnswer',
    'Shift',
    'TeamMembership',
    'TenantCampaign',
    'Vendor',
  ],
  'GET /api/Analytics/voter-demographics': [
    'Voter',
  ],
  'GET /api/Configuration/mapbox-token': [],
  'GET /api/Contacts': [
    'CampaignQuestion',
    'Contact',
    'ContactAnswer',
    'Volunteer',
    'Voter',
  ],
  'GET /api/Contacts/{id}': [
    'CampaignQuestion',
    'Contact',
    'ContactAnswer',
    'Volunteer',
    'Voter',
  ],
  'GET /api/ResourceLinks': [
    'ResourceLink',
  ],
  'GET /api/ResourceLinks/{id}': [
    'ResourceLink',
  ],
  'GET /api/Shifts': [
    'Shift',
    'TenantCampaign',
    'Volunteer',
    'Walkbook',
    'WalkbookAssignment',
  ],
  'GET /api/Shifts/{id}': [
    'Shift',
    'TenantCampaign',
    'Volunteer',
    'Walkbook',
  ],
  'GET /api/Tasks': [
    'CampaignTask',
    'TaskCategory',
    'Volunteer',
  ],
  'GET /api/Tasks/unacknowledged-count': [
    'CampaignTask',
  ],
  'GET /api/Tasks/{id}': [
    'CampaignTask',
    'Shift',
    'TaskCategory',
    'Volunteer',
    'Voter',
  ],
  'GET /api/Teams': [
    'Team',
    'TeamMembership',
    'Volunteer',
  ],
  'GET /api/Teams/{id}': [
    'Team',
    'TeamMembership',
    'Volunteer',
  ],
  'GET /api/VolunteerResources': [
    'VolunteerResource',
  ],
  'GET /api/VolunteerResources/{resourceType}': [
    'VolunteerResource',
  ],
  'GET /api/Volunteers/leaderboard': [
    'Contact',
    'Volunteer',
  ],
  'GET /api/Volunteers/stats': [
    'Contact',
    'Voter',
  ],
  'GET /api/VoterImport/geocoding-stats': [
    'Voter',
  ],
  'GET /api/VoterImport/history': [
    'ImportJob',
    'Volunteer',
  ],
  'GET /api/VoterImport/{jobId}/records': [
    'ImportJob',
    'ImportJobRecord',
  ],
  'GET /api/VoterTags': [
    'Volunteer',
    'VoterTag',
    'VoterTagAssignment',
  ],
  'GET /api/VoterTags/{id}': [
    'Volunteer',
    'Voter',
    'VoterTag',
    'VoterTagAssignment',
  ],
  'GET /api/Voters': [
    'Voter',
    'VoterTag',
    'VoterTagAssignment',
    'WalkbookHouse',
  ],
  'GET /api/Voters/filter-options': [
    'Voter',
  ],
  'GET /api/Voters/map-points': [
    'Voter',
    'VoterTagAssignment',
  ],
  'GET /api/Voters/nearest': [
    'Voter',
    'VoterTag',
    'VoterTagAssignment',
  ],
  'GET /api/Voters/search': [
    'Voter',
  ],
  'GET /api/Voters/{id}': [
    'Contact',
    'Voter',
    'VoterFileElection',
    'VoterTag',
    'VoterTagAssignment',
    'VoterVote',
  ],
  'GET /api/Walkbooks': [
    'Shift',
    'TenantCampaign',
    'Volunteer',
    'Walkbook',
    'WalkbookAssignment',
    'WalkbookHouse',
  ],
  'GET /api/Walkbooks/contact-rates': [
    'Walkbook',
    'WalkbookHouse',
  ],
  'GET /api/Walkbooks/{id}': [
    'Volunteer',
    'Walkbook',
    'WalkbookAssignment',
    'WalkbookHouse',
  ],
  'GET /api/Walkbooks/{id}/assignments': [
    'Volunteer',
    'Walkbook',
    'WalkbookAssignment',
    'WalkbookHouse',
  ],
  'GET /api/Walkbooks/{id}/houses': [
    'CampaignQuestion',
    'Contact',
    'ContactAnswer',
    'Volunteer',
    'Voter',
    'Walkbook',
    'WalkbookAssignment',
    'WalkbookHouse',
  ],
  'GET /api/Walkbooks/{id}/progress': [
    'Volunteer',
    'Walkbook',
    'WalkbookAssignment',
    'WalkbookHouse',
  ],
  'GET /api/admin/assistant-telemetry/charge-questions': [
    'AssistantProposal',
    'BankTransaction',
    'ChargeQuestion',
    'Contribution',
    'ContributionRefund',
    'Expenditure',
  ],
  'GET /api/admin/assistant-telemetry/overview': [
    'AssistantMessage',
    'AssistantMessageFeedback',
    'AssistantPush',
    'AssistantRun',
    'AssistantRunMetrics',
    'TenantCampaign',
  ],
  'GET /api/admin/assistant-telemetry/runs': [
    'AssistantMessage',
    'AssistantMessageFeedback',
    'AssistantRun',
    'AssistantRunMetrics',
    'TenantCampaign',
    'Volunteer',
  ],
  'GET /api/admin/assistant-telemetry/runs/{id}': [
    'AssistantMessage',
    'AssistantMessageFeedback',
    'AssistantRun',
    'AssistantRunMetrics',
    'AssistantRunRead',
    'TenantCampaign',
    'Volunteer',
  ],
  'GET /api/admin/assistant-test/campaigns': [
    'TenantCampaign',
  ],
  'GET /api/admin/assistant-test/members': [
    'AssistantAccessEntry',
    'AssistantMessage',
    'AssistantNote',
    'AssistantPushDevice',
    'AssistantThread',
    'AssistantWakeup',
    'CampaignUser',
    'CampaignUserCapability',
    'TenantCampaign',
    'Volunteer',
  ],
  'GET /api/analytics/attention-needed': [
    'CampaignQuestion',
    'CampaignUser',
    'Contact',
    'ContactAnswer',
    'DismissedFlag',
    'Shift',
    'TeamMembership',
    'TenantCampaign',
    'Vendor',
    'Volunteer',
  ],
  'GET /api/assistant/charge-questions/{lineId}': [
    'AssistantProposal',
    'BankLineCategoryGuess',
    'BankLinePayeeIdentification',
    'BankTransaction',
    'ChargeQuestion',
    'Contribution',
    'ContributionRefund',
    'Expenditure',
    'FinanceContact',
    'Volunteer',
  ],
  'GET /api/assistant/notes': [
    'AssistantNote',
  ],
  'GET /api/assistant/onboarding': [
    'AssistantPreference',
    'CampaignUser',
    'CampaignUserCapability',
    'ConsultantPlaybook',
    'TenantCampaign',
    'Volunteer',
  ],
  'GET /api/assistant/playbook': [
    'ConsultantPlaybook',
  ],
  'GET /api/assistant/preferences': [
    'AssistantPreference',
  ],
  'GET /api/assistant/proposals': [
    'AssistantProposal',
    'BankTransaction',
    'CallAttempt',
    'CallSession',
    'CallSheet',
    'CallSheetRow',
    'CampaignUser',
    'CampaignUserCapability',
    'Commitment',
    'Contribution',
    'Expenditure',
    'Prospect',
    'TenantCampaign',
    'Volunteer',
  ],
  'GET /api/assistant/proposals/{id}': [
    'AssistantProposal',
    'BankTransaction',
    'CallAttempt',
    'CallSession',
    'CallSheet',
    'CallSheetRow',
    'CampaignUser',
    'CampaignUserCapability',
    'Commitment',
    'Contribution',
    'Expenditure',
    'Prospect',
    'TenantCampaign',
    'Volunteer',
  ],
  'GET /api/assistant/thread/messages': [
    'AssistantMessage',
    'AssistantMessageFeedback',
    'AssistantThread',
  ],
  'GET /api/assistant/wakeups': [
    'AssistantWakeup',
  ],
  'GET /api/billing/beta-pricing': [
    'TenantCampaign',
  ],
  'GET /api/billing/config': [
    'TenantCampaign',
  ],
  'GET /api/billing/status': [
    'TenantCampaign',
    'WorkOrder',
  ],
  'GET /api/billing/trial-emails': [
    'TenantCampaign',
  ],
  'GET /api/calendar/campaign-visibility': [
    'CampaignUser',
    'TenantCampaign',
    'UserCampaignCalendarVisibility',
  ],
  'GET /api/calendar/campaigns/{campaignId}/settings': [
    'CalendarConnection',
    'CalendarSyncPreference',
    'CampaignCalendarSettings',
  ],
  'GET /api/calendar/conflicts': [
    'CalendarConnection',
    'CalendarSyncConflict',
  ],
  'GET /api/calendar/conflicts/all': [
    'CalendarConnection',
    'CalendarSyncConflict',
    'CampaignUser',
  ],
  'GET /api/calendar/conflicts/count': [
    'CalendarConnection',
    'CalendarSyncConflict',
  ],
  'GET /api/calendar/connections': [
    'CalendarConnection',
    'CalendarSyncPreference',
  ],
  'GET /api/calendar/connections/{id}/calendars': [
    'CalendarConnection',
    'CalendarSyncPreference',
  ],
  'GET /api/calendar/events': [
    'CalendarConnection',
    'CalendarEventCache',
    'CalendarSyncPreference',
    'CampaignUser',
    'ShiftCalendarLink',
    'TaskCalendarLink',
    'TenantCampaign',
    'UserCampaignCalendarVisibility',
  ],
  'GET /api/calendar/key-dates': [
    'CampaignFinanceSettings',
    'FilingDeadline',
  ],
  'GET /api/campaign-race': [
    'CampaignRace',
    'SavedVoteGoal',
    'Volunteer',
  ],
  'GET /api/campaign-race/goals': [
    'SavedVoteGoal',
    'Volunteer',
  ],
  'GET /api/campaigns/current': [
    'CampaignUser',
    'TenantCampaign',
    'Volunteer',
    'Voter',
    'WorkOrder',
  ],
  'GET /api/campaigns/my': [
    'AssistantAccessEntry',
    'CampaignUser',
    'CampaignUserCapability',
    'TenantCampaign',
    'Voter',
    'WorkOrder',
  ],
  'GET /api/campaigns/{campaignId}/consultant': [
    'TenantCampaign',
    'Volunteer',
  ],
  'GET /api/campaigns/{campaignId}/express-consultant': [
    'TenantCampaign',
    'Volunteer',
  ],
  'GET /api/campaigns/{id}/invitations': [
    'InvitationToken',
    'Vendor',
    'Volunteer',
  ],
  'GET /api/campaigns/{id}/questions': [
    'CampaignQuestion',
    'ContactAnswer',
    'Volunteer',
  ],
  'GET /api/campaigns/{id}/questions/report': [
    'CampaignQuestion',
    'Contact',
    'ContactAnswer',
  ],
  'GET /api/campaigns/{id}/users': [
    'CampaignUser',
    'CampaignUserCapability',
    'Team',
    'TeamMembership',
    'Vendor',
    'Volunteer',
  ],
  'GET /api/campaigns/{id}/voter-segments/by-answer/{questionId}': [
    'CampaignQuestion',
    'Contact',
    'ContactAnswer',
    'Volunteer',
    'Voter',
  ],
  'GET /api/express/{code}': [
    'Volunteer',
  ],
  'GET /api/express/{code}/campaigns': [
    'CampaignUser',
    'TenantCampaign',
    'Volunteer',
    'WorkOrder',
  ],
  'GET /api/finance/audit-logs': [
    'FinanceAuditLog',
    'TenantCampaign',
    'Volunteer',
  ],
  'GET /api/finance/audit-logs/actions': [
    'FinanceAuditLog',
  ],
  'GET /api/finance/audit-logs/entity-types': [
    'FinanceAuditLog',
  ],
  'GET /api/finance/bank-connections': [
    'BankConnection',
  ],
  'GET /api/finance/bank-ingestion/accounts': [
    'BankAccount',
  ],
  'GET /api/finance/bank-source-profiles/{id}': [
    'BankSourceProfile',
  ],
  'GET /api/finance/bank-transactions/{id}/processor-fee-check': [
    'BankTransaction',
    'Expenditure',
    'FilingDeadline',
    'PaymentProcessor',
  ],
  'GET /api/finance/bank-transactions/{id}/receipt-suggestions': [
    'BankTransaction',
    'CapturedReceipt',
  ],
  'GET /api/finance/captures/checks/mine': [
    'Contribution',
    'ContributionAttachment',
    'FinanceContact',
  ],
  'GET /api/finance/close/current': [
    'CampaignFinanceSettings',
    'ComplianceReport',
    'DuplicateContactFlag',
    'FilingDeadline',
    'PriorFilingAttestation',
    'TenantCampaign',
  ],
  'GET /api/finance/committee-formation/attestations': [
    'PriorFilingAttestation',
  ],
  'GET /api/finance/committee-formation/missed-deadlines': [
    'CampaignFinanceSettings',
    'FilingDeadline',
    'PriorFilingAttestation',
    'TenantCampaign',
  ],
  'GET /api/finance/compliance-profile': [
    'CampaignFinanceSettings',
    'TenantCampaign',
  ],
  'GET /api/finance/compliance/al-daily-window': [
    'CampaignFinanceSettings',
    'TenantCampaign',
  ],
  'GET /api/finance/contacts': [
    'CampaignFinanceSettings',
    'Contribution',
    'FinanceContact',
    'Loan',
    'TenantCampaign',
  ],
  'GET /api/finance/contacts/{id}': [
    'CampaignFinanceSettings',
    'Contribution',
    'FinanceContact',
    'Loan',
    'TenantCampaign',
  ],
  'GET /api/finance/contribution-refunds': [
    'ContributionRefund',
  ],
  'GET /api/finance/contributions': [
    'Contribution',
    'FinanceContact',
  ],
  'GET /api/finance/contributions/{id}/detail': [
    'BankTransaction',
    'ComplianceReport',
    'Contribution',
    'ContributionRefund',
    'FinanceContact',
    'SubmissionPackage',
    'SubmissionPackageContribution',
    'TransactionFlag',
  ],
  'GET /api/finance/contributions/{id}/donor-info-request-history': [
    'Contribution',
    'DonorInfoRequest',
  ],
  'GET /api/finance/contributions/{id}/manual-void-prefill': [
    'Contribution',
    'TenantCampaign',
  ],
  'GET /api/finance/contributions/{id}/resolutions': [
    'Contribution',
    'ContributionRefund',
    'FinanceContact',
  ],
  'GET /api/finance/dashboard/attention': [
    'BlockedContributionAttempt',
    'CampaignFinanceSettings',
    'Contribution',
    'DonorInfoRequest',
    'DuplicateContactFlag',
    'FinanceContact',
    'Loan',
    'TenantCampaign',
  ],
  'GET /api/finance/dashboard/last-filed-cash': [
    'CampaignFinanceSettings',
    'ComplianceReport',
    'FilingDeadline',
    'FinanceAuditLog',
    'TenantCampaign',
  ],
  'GET /api/finance/dashboard/roster': [
    'BankAccount',
    'BankConnection',
    'BankTransaction',
    'ImportBatch',
    'PaymentProcessor',
    'TenantCampaign',
  ],
  'GET /api/finance/dashboard/summary': [
    'CampaignFinanceSettings',
    'Contribution',
    'Expenditure',
    'TenantCampaign',
  ],
  'GET /api/finance/deadlines': [
    'CampaignFinanceSettings',
    'ComplianceReport',
    'FilingDeadline',
    'JurisdictionReportingSchedule',
    'TenantCampaign',
  ],
  'GET /api/finance/debts': [
    'Debt',
    'Expenditure',
    'FinanceContact',
  ],
  'GET /api/finance/duplicate-contact-flags': [
    'CampaignFinanceSettings',
    'ComplianceReport',
    'Contribution',
    'DuplicateContactFlag',
    'Expenditure',
    'FinanceContact',
    'PaymentProcessor',
  ],
  'GET /api/finance/election-outcomes': [
    'ElectionOutcome',
    'TenantCampaign',
  ],
  'GET /api/finance/election-outcomes/current': [
    'ElectionOutcome',
  ],
  'GET /api/finance/expenditures': [
    'Expenditure',
    'FinanceContact',
  ],
  'GET /api/finance/expenditures/{id}/detail': [
    'BankTransaction',
    'Expenditure',
    'FinanceContact',
    'TransactionFlag',
  ],
  'GET /api/finance/formats': [],
  'GET /api/finance/health': [
    'BankTransaction',
    'CampaignFinanceSettings',
    'ComplianceReport',
    'Contribution',
    'ContributionRefund',
    'DonorInfoRequest',
    'Expenditure',
    'ExportBatch',
    'ExportBatchMember',
    'FilingDeadline',
    'FinanceAuditLog',
    'FinanceContact',
    'JurisdictionReportingSchedule',
    'Loan',
    'PriorFilingAttestation',
    'TenantCampaign',
    'TransactionFlag',
  ],
  'GET /api/finance/import-batches/history': [
    'BankAccount',
    'BankTransaction',
    'Contribution',
    'ImportBatch',
  ],
  'GET /api/finance/import-batches/{id}/undo-preview': [
    'BankTransaction',
    'Contribution',
    'Expenditure',
    'ImportBatch',
  ],
  'GET /api/finance/loans': [
    'FinanceContact',
    'Loan',
    'LoanGuarantor',
  ],
  'GET /api/finance/manual-p2p/unattributed-deposits': [
    'BankTransaction',
    'Contribution',
    'ContributionRefund',
    'Expenditure',
    'PaymentProcessor',
  ],
  'GET /api/finance/metrics': [
    'FilingDeadline',
    'FinanceAnalyticsEvent',
    'TenantCampaign',
  ],
  'GET /api/finance/metrics/provider': [
    'FinanceAnalyticsEvent',
  ],
  'GET /api/finance/obligations': [
    'CampaignFinanceSettings',
    'ComplianceReport',
    'Contribution',
    'Expenditure',
    'FilingDeadline',
    'FilingObligation',
    'FinanceContact',
    'JurisdictionReportingSchedule',
    'Loan',
    'TenantCampaign',
  ],
  'GET /api/finance/onboarding/catalog': [
    'BankSourceProfile',
  ],
  'GET /api/finance/onboarding/status': [
    'BankAccount',
    'BankSourceProfile',
    'CampaignFinanceSettings',
    'PaymentProcessor',
  ],
  'GET /api/finance/organization-type-conflicts': [
    'FinanceAuditLog',
    'FinanceContact',
  ],
  'GET /api/finance/payments/donation-config': [
    'CampaignFinanceSettings',
  ],
  'GET /api/finance/payments/donations': [
    'Contribution',
    'ContributionRefund',
    'FinanceContact',
  ],
  'GET /api/finance/payments/donations/{contributionId}': [
    'Contribution',
    'ContributionRefund',
    'FinanceContact',
  ],
  'GET /api/finance/payments/needs-attention': [
    'Contribution',
    'ContributionRefund',
    'FinanceContact',
  ],
  'GET /api/finance/payments/status': [
    'StripeConnectAccount',
    'StripeConnectWebhookEvent',
    'TenantCampaign',
  ],
  'GET /api/finance/payments/summary': [
    'Contribution',
    'StripeConnectAccount',
    'TenantCampaign',
  ],
  'GET /api/finance/processor-fees/{processorId}/donations': [
    'CampaignFinanceSettings',
    'ComplianceReport',
    'Contribution',
    'FilingDeadline',
    'FinanceContact',
    'ImportBatch',
    'PaymentProcessor',
    'PriorFilingAttestation',
    'TenantCampaign',
  ],
  'GET /api/finance/processors': [
    'PaymentProcessor',
  ],
  'GET /api/finance/processors/{id}/threshold-impact': [
    'Contribution',
    'ImportBatch',
    'PaymentProcessor',
  ],
  'GET /api/finance/recurring': [
    'CampaignFinanceSettings',
    'RecurringDonation',
    'TenantCampaign',
  ],
  'GET /api/finance/recurring/donors': [
    'FinanceContact',
    'RecurringDonation',
  ],
  'GET /api/finance/reports': [
    'CampaignFinanceSettings',
    'ComplianceReport',
    'Contribution',
    'ContributionRefund',
    'Debt',
    'Expenditure',
    'ExportBatch',
    'ExportBatchMember',
    'FilingDeadline',
    'FinanceAuditLog',
    'FinanceContact',
    'ImportBatch',
    'Loan',
    'LoanGuarantor',
    'PortalEntryRun',
    'PortalFollowUp',
    'SubmissionPackage',
    'SubmissionPackageAttestation',
    'SubmissionPackageContribution',
    'SubmissionPackageExpenditure',
    'SubmissionPackageRefund',
    'TenantCampaign',
  ],
  'GET /api/finance/reports/cash-recalc-preview': [
    'CampaignFinanceSettings',
    'ComplianceReport',
    'TenantCampaign',
  ],
  'GET /api/finance/reports/preview': [
    'BankTransaction',
    'CampaignFinanceSettings',
    'ComplianceReport',
    'Contribution',
    'ContributionRefund',
    'Debt',
    'DonorInfoRequest',
    'Expenditure',
    'ExportBatch',
    'ExportBatchMember',
    'FilingDeadline',
    'FilingObligation',
    'FinanceAuditLog',
    'FinanceContact',
    'ImportBatch',
    'JurisdictionReportingSchedule',
    'Loan',
    'LoanGuarantor',
    'PriorFilingAttestation',
    'SubmissionPackage',
    'SubmissionPackageAttestation',
    'TenantCampaign',
    'TransactionFlag',
  ],
  'GET /api/finance/reports/{id}': [
    'BankTransaction',
    'CampaignFinanceSettings',
    'ComplianceReport',
    'Contribution',
    'ContributionRefund',
    'Debt',
    'DonorInfoRequest',
    'DuplicateContactFlag',
    'Expenditure',
    'ExportBatch',
    'ExportBatchMember',
    'FilingDeadline',
    'FilingObligation',
    'FinanceAuditLog',
    'FinanceContact',
    'ImportBatch',
    'Loan',
    'LoanGuarantor',
    'PaymentProcessor',
    'PortalFollowUp',
    'PriorFilingAttestation',
    'SubmissionPackage',
    'SubmissionPackageAttestation',
    'TenantCampaign',
  ],
  'GET /api/finance/reports/{id}/chain': [
    'ComplianceReport',
    'SubmissionPackage',
  ],
  'GET /api/finance/reports/{id}/mark-filed-preview': [
    'CampaignFinanceSettings',
    'ComplianceReport',
    'Contribution',
    'Expenditure',
    'ExportBatch',
    'ExportBatchMember',
    'SubmissionPackage',
    'TenantCampaign',
  ],
  'GET /api/finance/reports/{id}/portal-follow-ups': [
    'PortalFollowUp',
  ],
  'GET /api/finance/reports/{id}/preflight': [
    'CampaignFinanceSettings',
    'ComplianceReport',
    'Contribution',
    'ContributionRefund',
    'DonorInfoRequest',
    'DuplicateContactFlag',
    'Expenditure',
    'ExportBatch',
    'ExportBatchMember',
    'FilingObligation',
    'FinanceAuditLog',
    'FinanceContact',
    'ImportBatch',
    'Loan',
    'PaymentProcessor',
    'ProcessorFeeStepAside',
    'SubmissionPackage',
    'SubmissionPackageAttestation',
    'TenantCampaign',
  ],
  'GET /api/finance/reports/{id}/preview': [
    'CampaignFinanceSettings',
    'ComplianceReport',
    'Contribution',
    'DonorInfoRequest',
    'Expenditure',
    'FinanceContact',
    'SubmissionPackage',
    'SubmissionPackageAttestation',
  ],
  'GET /api/finance/reports/{id}/reopen-advisory': [
    'ComplianceReport',
    'FilingDeadline',
    'FinanceAuditLog',
  ],
  'GET /api/finance/reports/{id}/send-status': [
    'CampaignFinanceSettings',
    'FilingEmailSend',
    'FinanceAuditLog',
  ],
  'GET /api/finance/reports/{id}/signing-evidence': [
    'ComplianceReport',
    'Contribution',
    'ContributionRefund',
    'Expenditure',
    'FinanceContact',
    'Loan',
    'SubmissionPackage',
    'SubmissionPackageAttestation',
    'SubmissionPackageContribution',
    'SubmissionPackageExpenditure',
    'SubmissionPackageLoan',
    'SubmissionPackageRefund',
    'Volunteer',
  ],
  'GET /api/finance/reports/{reportId}/portal-run': [
    'PortalEntryRun',
  ],
  'GET /api/finance/rulesets': [],
  'GET /api/finance/rulesets/{code}': [],
  'GET /api/finance/rulesets/{code}/expense-purposes': [],
  'GET /api/finance/rulesets/{code}/report-types': [],
  'GET /api/finance/rulesets/{code}/schedule': [],
  'GET /api/finance/rulesets/{code}/source': [],
  'GET /api/finance/rulesets/{code}/statutory-election-dates': [],
  'GET /api/finance/settings': [
    'CampaignFinanceSettings',
    'FinanceContact',
    'TenantCampaign',
  ],
  'GET /api/finance/sort-inbox': [
    'BankAccount',
    'BankLinePayeeIdentification',
    'BankTransaction',
    'CampaignFinanceSettings',
    'ComplianceReport',
    'Contribution',
    'ContributionAttachment',
    'ContributionRefund',
    'DonorInfoRequest',
    'Expenditure',
    'ExportBatch',
    'ExportBatchMember',
    'FilingDeadline',
    'FinanceAuditLog',
    'FinanceContact',
    'ImportBatch',
    'Loan',
    'PaymentProcessor',
    'PriorFilingAttestation',
    'ProcessorFeeStepAside',
    'TenantCampaign',
  ],
  'GET /api/finance/staged/earliest-date': [
    'Contribution',
    'Expenditure',
  ],
  'GET /api/finance/straggler-alerts': [
    'FinanceAuditLog',
  ],
  'GET /api/fundraising/call-sessions': [
    'CallAttempt',
    'CallSession',
    'CallSheet',
    'CallSheetRow',
    'FundraisingSettings',
    'TenantCampaign',
    'Volunteer',
  ],
  'GET /api/fundraising/call-sessions/dials-per-hour': [
    'FundraisingSettings',
  ],
  'GET /api/fundraising/call-sessions/moves': [
    'CallSession',
    'CallSessionMove',
    'CallSheet',
    'Volunteer',
  ],
  'GET /api/fundraising/call-sheets/{id}': [
    'CallAttempt',
    'CallSheet',
    'CallSheetRow',
    'CampaignFinanceSettings',
    'Commitment',
    'Prospect',
    'TenantCampaign',
  ],
  'GET /api/fundraising/call-time/donors/{prospectId}/profile': [
    'CallAttempt',
    'CallSheet',
    'CallSheetRow',
    'CampaignFinanceSettings',
    'Commitment',
    'CommitmentCheckIn',
    'FollowUp',
    'Match',
    'MatchVerdict',
    'Prospect',
    'TenantCampaign',
    'Volunteer',
  ],
  'GET /api/fundraising/call-time/follow-up-drafts': [
    'FundraisingSettings',
    'TenantCampaign',
  ],
  'GET /api/fundraising/call-time/queue': [
    'CallAttempt',
    'CampaignFinanceSettings',
    'Commitment',
    'Match',
    'MatchVerdict',
    'Prospect',
    'TenantCampaign',
    'Volunteer',
  ],
  'GET /api/fundraising/call-time/sessions': [
    'CallAttempt',
    'CallSession',
    'CallSheet',
    'CallSheetRow',
    'FundraisingSettings',
    'TenantCampaign',
    'Volunteer',
  ],
  'GET /api/fundraising/call-time/sheets': [
    'CallAttempt',
    'CallSheet',
    'CallSheetRow',
    'TenantCampaign',
    'Volunteer',
  ],
  'GET /api/fundraising/call-time/sheets/{id}/queue': [
    'CallAttempt',
    'CallSheet',
    'CallSheetRow',
    'CampaignFinanceSettings',
    'Commitment',
    'Match',
    'MatchVerdict',
    'Prospect',
    'TenantCampaign',
    'Volunteer',
  ],
  'GET /api/fundraising/commitments': [
    'CallAttempt',
    'Commitment',
    'CommitmentCheckIn',
    'Match',
    'MatchVerdict',
    'Prospect',
    'TenantCampaign',
    'Volunteer',
  ],
  'GET /api/fundraising/enrichment/people': [
    'Match',
    'MatchVerdict',
  ],
  'GET /api/fundraising/enrichment/run': [],
  'GET /api/fundraising/follow-up-settings': [
    'FundraisingSettings',
    'TenantCampaign',
  ],
  'GET /api/fundraising/prospect-lists': [
    'ProspectList',
  ],
  'GET /api/fundraising/prospect-lists/{id}': [
    'ProspectList',
  ],
  'GET /api/fundraising/prospect-lists/{id}/undo-preview': [
    'CallAttempt',
    'Commitment',
    'ProspectList',
    'ProspectListMembership',
  ],
  'GET /api/fundraising/prospects': [
    'Prospect',
  ],
  'GET /api/fundraising/prospects/book': [
    'CallAttempt',
    'CallSheet',
    'CallSheetRow',
    'CampaignFinanceSettings',
    'Commitment',
    'Match',
    'MatchVerdict',
    'Prospect',
    'ProspectListMembership',
    'TenantCampaign',
    'Volunteer',
  ],
  'GET /api/fundraising/prospects/book/possible-matches': [
    'Match',
    'MatchVerdict',
    'Prospect',
  ],
  'GET /api/fundraising/prospects/book/summary': [
    'CallAttempt',
    'CallSheet',
    'CallSheetRow',
    'CampaignFinanceSettings',
    'Commitment',
    'Match',
    'MatchVerdict',
    'Prospect',
    'ProspectListMembership',
    'TenantCampaign',
  ],
  'GET /api/fundraising/prospects/{prospectId}/detail': [
    'CallAttempt',
    'CallSheet',
    'CallSheetRow',
    'CampaignFinanceSettings',
    'Commitment',
    'CommitmentCheckIn',
    'FollowUp',
    'Match',
    'MatchVerdict',
    'Prospect',
    'TenantCampaign',
    'Volunteer',
  ],
  'GET /api/legal/current-versions': [
    'LegalDocumentVersion',
  ],
  'GET /api/legal/document': [
    'LegalDocumentVersion',
  ],
  'GET /api/messaging/profile': [
    'CampaignMessagingProfile',
  ],
  'GET /api/messaging/profile/committee': [
    'CampaignMessagingProfile',
    'TenantCampaign',
    'TextSendDetails',
    'Volunteer',
    'WorkOrder',
  ],
  'GET /api/messaging/profiles': [
    'CampaignMessagingProfile',
    'TenantCampaign',
    'WorkOrder',
  ],
  'GET /api/onboarding/menu': [
    'TenantCampaign',
  ],
  'GET /api/onboarding/status': [
    'CampaignUser',
  ],
  'GET /api/platform/race-catalog/states': [],
  'GET /api/platform/race-catalog/states/{state}/rollback': [],
  'GET /api/races': [],
  'GET /api/races/{id}': [],
  'GET /api/task-categories': [
    'TaskCategory',
    'TaskCategoryAccess',
  ],
  'GET /api/task-categories/hidden': [
    'TaskCategory',
    'TaskCategoryAccess',
  ],
  'GET /api/text-status/{token}': [
    'CampaignMessagingProfile',
    'TenantCampaign',
    'TextSendDetails',
    'WorkOrder',
  ],
  'GET /api/text-status/{token}/results-report': [
    'TextSendDetails',
    'WorkOrder',
  ],
  'GET /api/vendors': [
    'CampaignUser',
    'Vendor',
  ],
  'GET /api/voice/consent-check': [
    'TenantCampaign',
  ],
  'GET /api/voice/recordings/{contactId}': [
    'TenantCampaign',
    'VoiceRecording',
    'VoiceRecordingContact',
  ],
  'GET /api/voter-data/places/match': [
    'CampaignRace',
  ],
  'GET /api/voter-list/{token}': [
    'VoterDataDetails',
    'WorkOrder',
  ],
  'GET /api/work-orders': [
    'VoterDataDetails',
    'WorkOrder',
  ],
  'GET /api/work-orders/voter-data/queue': [
    'TenantCampaign',
    'VoterDataDetails',
    'WorkOrder',
  ],
  'GET /api/work-orders/{id}': [
    'ImportJob',
    'TenantCampaign',
    'TextSendDetails',
    'Voter',
    'VoterDataDetails',
    'WorkOrder',
  ],
  'GET /api/work-orders/{id}/checkout-preview': [
    'ImportJob',
    'TenantCampaign',
    'TextSendDetails',
    'Voter',
    'VoterDataDetails',
    'WorkOrder',
  ],
  'GET /api/work-orders/{id}/results-report': [
    'TextSendDetails',
    'WorkOrder',
  ],
} as const satisfies Record<string, readonly EntityTag[]>;
